import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import numeral from 'numeral';
import { 
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@mui/material';
import { Container, ClearIcon, EmptyMsg } from './styles';
import PropTypes from 'prop-types';
import { getIndicatorDetails } from '../../actions';
import IndicatorDetails from '../IndicatorDetails';
import { TitleCard, TitleTotal } from '../styles';

export const ImpactsCard = React.memo(({ headers, rows, card, saveCardSettings, showSettings, expanded }) => {
  const dispatch = useDispatch();
  const [ selectedIndicatorId, setSelectedIndicatorId ] = useState(null);
  const indicators = useSelector(state => state.filters.indicators);
  const { indicatorDetails: details, indicatorLoading: loading } = useSelector(state => state.details);

  const handleOnRemove = (indicatorId) => {
    const { settings } = card;
    const form = { ...settings };
    if (form.indicators.length > 0) {
      form.indicators = form.indicators.filter(ind => ind !== indicatorId);
    } else {
      form.indicators = indicators.filter(ind => ind !== indicatorId);
    }
    saveCardSettings(card, form);
  };

  const emptyMsg = (card && card.settings && card.settings.indicators.length === 0) ?
    'You have not selected any indicators, at least one indicator is required.' :
    'No results mathing your configured filters.';

  const handleOnPressRow = (indicatorId) => {
    dispatch(getIndicatorDetails(indicatorId));
    setSelectedIndicatorId(indicatorId);
  };

  const handleClose = () => {
    setSelectedIndicatorId(null);
  };

  return (
    <Container expanded={expanded}>
      <TableContainer>
        { rows && rows.length > 0 && (
          <Table>
            <TableHead>
              <TableRow>
                { headers.map((header, index) => (
                  <TableCell key={index} style={{ textAlign: 'left', padding: 8 }}><TitleTotal>{header}</TitleTotal></TableCell>
                ))}
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row) => (
                <React.Fragment key={row['Indicators']}>
                  <TableRow>
                    { headers.map((header, index) => (
                      <TableCell style={{
                        cursor: (index === 0) ? 'pointer' : 'inherit',
                        textAlign: 'left',
                        padding: 8,
                      }} key={index} onClick={() => {
                        if (index === 0) handleOnPressRow(row['Indicators']);
                      }}>{row[header]}</TableCell>
                    ))}
                    {
                      showSettings &&
                      <TableCell style={{padding: '5px'}}>
                        <ClearIcon onClick={() => handleOnRemove(row['Indicators'])}/>
                      </TableCell>
                    }
                  </TableRow>
                  { (selectedIndicatorId === row['Indicators']) && (
                    <TableRow>
                      <TableCell colSpan={headers.length} style={{padding: '5px'}}>
                        <IndicatorDetails
                          loading={loading}
                          list={details}
                          onClose={() => handleClose()}
                        />
                      </TableCell>
                    </TableRow>
                  )}
                </React.Fragment>
              ))}
            </TableBody>
          </Table>
        )}
        { rows && rows.length === 0 && (
          <EmptyMsg centered>{ emptyMsg }</EmptyMsg>
        )}
      </TableContainer>
    </Container>
  );
});

ImpactsCard.propTypes = {
  headers: PropTypes.array,
  rows: PropTypes.array,
  settings: PropTypes.object,
  card: PropTypes.object,
  saveCardSettings: PropTypes.func,
  showSettings: PropTypes.bool
};
